// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("src/static/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-border-radius {
  border-radius: 5.25px;
  overflow: hidden;
}
.component-news-list-item {
  border: #f1f1f1 1px solid;
  cursor: pointer;
  display: flex;
  margin-bottom: 20px;
  padding: 35px;
  max-width: 500px;
}
.component-news-list-item:hover .component-news-img {
  transform: scale(1.03);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.25, 1) 0ms;
}
.component-news-list-item:hover .component-news-img:after {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.25, 1) 0ms;
}
.component-news-list-item:visited {
  color: #222;
  text-decoration: none;
}
.component-news-list-item:active {
  text-decoration: none;
}
.common-font-size-21 {
  color: #222;
  font-size: 21px;
}
.common-font-size-12 {
  color: #222;
  font-size: 12.25px;
}
.component-news-list-item .mobile-new-item {
  display: none;
}
.component-news-img {
  display: block;
  height: 140px;
  overflow: hidden;
  position: relative;
  transition: transform 0.8s cubic-bezier(0.4, 0, 0.25, 1) 0ms, opacity 1s cubic-bezier(0.4, 0, 0.25, 1) 0ms;
  width: 140px;
}
.component-news-img img {
  width: 100%;
}
.component-news-img:after {
  background: transparent;
  content: "";
  display: inline-block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transition: background 0.4s cubic-bezier(0.4, 0, 0.25, 1) 0ms;
  width: 100%;
  z-index: 2;
}
.component-news-info {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-left: 36.75px;
}
.component-news-info .component-title {
  flex: 1;
}
.component-news-info .date-author {
  align-items: center;
  border-top: 0.875px solid #eaeaea;
  color: #222;
  display: flex;
  font-size: 12.25px;
  height: 35px;
  justify-content: space-between;
  position: relative;
}
.component-news-info .date-author:before {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}
.component-news-info .date-author .component-author {
  height: 14px;
  width: 75.25px;
}
.component-author {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}
.component-news-info .date-author .author-arrow {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}
.news-tabs-wrapper .ant-row > div {
  width: 45%;
}
`, "",{"version":3,"sources":["webpack://./src/views/news/components/NewsCard/newsCard.less"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,gBAAA;AADF;AAIA;EAEE,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAHF;AAKE;EAEI,sBAAA;EACA,4DAAA;AAJN;AAMM;EAEE,4DAAA;AALR;AAUE;EACE,WAAA;EACA,qBAAA;AARJ;AAWE;EACE,qBAAA;AATJ;AAaA;EACE,WAAA;EAEA,eAAA;AAZF;AAeA;EACE,WAAA;EAEA,kBAAA;AAdF;AAiBA;EACE,aAAA;AAfF;AAkBA;EAEE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,0GAAA;EACA,YAAA;AAjBF;AAUA;EAUI,WAAA;AAjBJ;AAoBE;EACE,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,6DAAA;EACA,WAAA;EACA,UAAA;AAlBJ;AAsBA;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EAEA,qBAAA;AArBF;AAgBA;EAQI,OAAA;AArBJ;AAaA;EAYI,mBAAA;EACA,iCAAA;EACA,WAAA;EACA,aAAA;EAEA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AAvBN;AALA;EAgCM,YAAA;EACA,cAAA;AAxBN;AA8BA;EACE,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,kCAAA;AA5BF;AA+BA;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;AA7BF;AAgCA;EAEI,UAAA;AA/BJ","sourcesContent":["@fontsize: 14px;\n\n.common-border-radius {\n  border-radius: .375*@fontsize;\n  overflow: hidden\n}\n\n.component-news-list-item {\n  // background-color: #fafafa;\n  border: #f1f1f1 1px solid;\n  cursor: pointer;\n  display: flex;\n  margin-bottom: 20px;\n  padding: 2.5*@fontsize;\n  max-width: 500px;\n\n  &:hover {\n    .component-news-img {\n      transform: scale(1.03);\n      transition: transform .4s cubic-bezier(.4, 0, .25, 1) 0ms;\n\n      &:after {\n        //background: rgba(0,0,0,.15);\n        transition: transform .4s cubic-bezier(.4, 0, .25, 1) 0ms\n      }\n    }\n  }\n\n  &:visited {\n    color: #222;\n    text-decoration: none\n  }\n\n  &:active {\n    text-decoration: none\n  }\n}\n\n.common-font-size-21 {\n  color: #222;\n  //font-family: AlibabaPuHuiTi;\n  font-size: 1.5*@fontsize;\n}\n\n.common-font-size-12 {\n  color: #222;\n  //font-family: AlibabaPuHuiTi;\n  font-size: .875*@fontsize\n}\n\n.component-news-list-item .mobile-new-item {\n  display: none\n}\n\n.component-news-img {\n  //background-color: #d8d8d8;\n  display: block;\n  height: 10*@fontsize;\n  overflow: hidden;\n  position: relative;\n  transition: transform .8s cubic-bezier(.4, 0, .25, 1) 0ms, opacity 1s cubic-bezier(.4, 0, .25, 1) 0ms;\n  width: 10*@fontsize;\n\n  img {\n    width: 100%\n  }\n\n  &:after {\n    background: transparent;\n    content: \"\";\n    display: inline-block;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    transition: background .4s cubic-bezier(.4, 0, .25, 1) 0ms;\n    width: 100%;\n    z-index: 2\n  }\n}\n\n.component-news-info {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  // height: 100%;\n  padding-left: 2.625*@fontsize;\n\n  .component-title {\n    flex: 1\n  }\n\n  .date-author {\n    align-items: center;\n    border-top: .0625*@fontsize solid #eaeaea;\n    color: #222;\n    display: flex;\n    //font-family: AlibabaPuHuiTi;\n    font-size: .875*@fontsize;\n    height: 2.5*@fontsize;\n    justify-content: space-between;\n    position: relative;\n\n    &:before {\n      content: \"\";\n      display: block;\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 100%\n    }\n\n    .component-author {\n      height: 1*@fontsize;\n      width: 5.375*@fontsize;\n    }\n  }\n}\n\n\n.component-author {\n  background-image: url(\"src/static/logo.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center center;\n}\n\n.component-news-info .date-author .author-arrow {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end\n}\n\n.news-tabs-wrapper {\n  .ant-row > div {\n    width: 45%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
